<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M-9.28,788.12c1.28,0.34,3.49,2.31,4.9,4.74l1.75,1.15l1.4,2.43l-4.87,2.81l-1.41-2.43l-0.13-2.09
	C-9.03,792.3-9.62,789.4-9.28,788.12L-9.28,788.12z M-4.42,785.31c1.28,0.34,3.5,2.31,4.9,4.74l1.75,1.15l1.41,2.43l-3.25,1.87
	l-1.41-2.43l-1.75-1.15C-4.16,789.49-4.76,786.59-4.42,785.31L-4.42,785.31z M0.45,782.5c1.28,0.34,3.5,2.31,4.9,4.74l1.75,1.15
	l1.4,2.43l-3.24,1.87l-1.4-2.43l-1.75-1.15C0.7,786.68,0.11,783.78,0.45,782.5L0.45,782.5z M-0.29,798.07l0.94,1.62l-4.87,2.81
	l-0.94-1.62L-0.29,798.07z M4.57,795.26l0.94,1.62l-3.25,1.87l-0.94-1.62L4.57,795.26z M9.44,792.45l0.94,1.62l-3.24,1.87
	l-0.94-1.62L9.44,792.45z"/>
</svg>

</template>